//
//
//
//
//
//
//
//


export default {
  props: {
    htmlTag: {
      type: String,
      required: false,
      default: 'h2',
    },
    marginBottom: {
      type: Number,
      required: false,
      // The default is sized to align well with the following section if it uses a TW size 20 top margin. If the section uses a different margin, users need to find the correct value by trial and error.
      default: -12,
    },
    marginTop: {
      type: Number,
      required: false,
      default: 20,
    }
  },

  data () {
    return {
      marginBottomRem: this.marginBottom * 0.25,
      marginTopRem: this.marginTop * 0.25,
    }
  }
}

